import { useNewSubjectStore } from '../../modules/Disciplines/stores/newSubjectStore';
import axiosInstance from '../api/axios';
import { usePrintComponentRequestStore } from '../components/organism/PrintComponent/store/usePrintComponentRequest';
import { INewExercise } from '../models/new_exercise';

export async function getExercisesPrint(subarea: string) {
  try {
    const state = usePrintComponentRequestStore.getState();
    const types = state.questionOptions;
    const difficulty = state.difficulty;
    const favorites = state.favorites;
    const unanswered = state.unanswered;
    const rightAnswer = state.rightAnswer;
    const wrongAnswer = state.wrongAnswer;
    const selectedYear = state.selectedYear;
    const institutionType = state.institutionType;
    const exerciseTypes = state.exerciseTypes;
    const subjectList = useNewSubjectStore.getState().selectedSubjects;

    const subjects =
      subjectList.length > 0 ? JSON.stringify([subjectList]) : '';
    const difficulties = JSON.stringify(difficulty);
    const questionsArray = JSON.stringify(types);
    const typesArray = JSON.stringify(exerciseTypes);
    const yearsArray = JSON.stringify(selectedYear);
    const institutionsArray = JSON.stringify(institutionType);

    let url = `/exercises/new/print?page=1`;

    url = url + `&difficulty=${difficulties}`;
    url = url + `&subject=${subjects}`;
    url = url + `&subarea=${subarea}`;
    url = url + `&questionOptions=${questionsArray}`;
    url = url + `&exerciseTypes=${typesArray}`;
    url = url + `&selectedYear=${yearsArray}`;
    url = url + `&institutionType=${institutionsArray}`;

    if (favorites) {
      url = url + `&favorites=${favorites}`;
    }

    if (unanswered) {
      url = url + `&unanswered=${unanswered}`;
    }

    if (rightAnswer) {
      url = url + `&rightAnswer=${rightAnswer}`;
    }

    if (wrongAnswer) {
      url = url + `&wrongAnswer=${wrongAnswer}`;
    }

    const { data } = await axiosInstance.get(url);

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getExerciseBySlug(slug: string): Promise<INewExercise> {
  try {
    const response = await axiosInstance.get(`/exercises/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
